













import Component from 'vue-class-component';

// The base for every input component
import InputBase from './Base.vue';

@Component
export default class InputEmail extends InputBase<string> {}
